<template>
  <div>
    <van-nav-bar
      title="代金券"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <van-cell-group v-if="loadSuccess">
      <van-cell title="券号" :value="temp.TicketCode" />
      <van-cell title="券金额" :value="temp.TicketAmount" />
      <van-cell title="核销状态" :value="temp.UseStatus" />
      <template v-if="canUse == 1">
        <van-cell title="客户姓名" :value="temp.CustomerName" />
        <van-cell title="客户电话" :value="temp.CustomerPhone" />
        <!-- <van-cell title="客户地址" value="" :label="temp.CustomerAddress" /> -->
        <van-cell title="客户地址" :value="temp.CustomerAddress" />
      </template>
    </van-cell-group>
    <div v-if="!showLoading" style="padding: 20px; padding-top: 50px">
      <van-button v-if="canUse == 1" type="primary" block @click="handleUseTicket" :loading="saveLoading">核销代金券</van-button>
      <van-button v-else type="warning" block @click="onClickLeft">返回</van-button>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      showLoading: true,
      saveLoading: false,
      loadSuccess: false,
      ticketId: "",
      temp: {
        TicketCode: null,
        TicketAmount: null,
        IsSend: null,
        IsUse: null,
        UseStatus: null,
        CustomerName: null,
        CustomerPhone: null,
        CustomerAddress: null,
      },
      canUse: 0,
    };
  },
  mounted() {
    this.ticketId = this.$route.query.id || "";
    this.showLoading = true
    this.loadSuccess = false;
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 0,
    });
    // return
    // 获取代金券信息
    this.$axios
      .get("/api/DjTicket/GetTicketInfo", {
        params: {
          TicketId: this.ticketId,
        },
      })
      .then((data) => {
        let res = data.data;
        this.showLoading = false
        Toast.clear();
        if (res.type != 1) {
          Dialog.alert({
            message: res.message,
          });
          return;
        }
        this.loadSuccess = true;
        let row = res.ticketEntity;
        for (var key in this.temp) {
          if (row.hasOwnProperty(key)) {
            this.temp[key] = row[key];
          }
        }
        this.canUse = res.canUse;
        if (this.temp.IsSend == 1) {
          if (this.temp.IsUse == 1) {
            this.temp.UseStatus = "已核销";
          } else {
            this.temp.UseStatus = "待使用";
          }
        } else {
          this.temp.UseStatus = "待发放";
        }
      });
  },
  methods: {
    onClickLeft() {
      // Toast("返回");
      this.$router.push("/");
    },
    // 核销代金券
    handleUseTicket() {
      if (this.saveLoading) {
        return;
      }
      Dialog.confirm({
        title: "确认",
        message: "确认【核销代金券】吗？",
      })
        .then(() => {
          this.saveLoading = true;
          this.$axios
            .post("/api/DjTicket/UseTicket", {
              TicketId: this.ticketId,
            })
            .then((data) => {
              let res = data.data;
              this.saveLoading = false;
              if (res.type == 1) {
                Toast.success({
                  message: res.message,
                  duration: 500,
                });
                this.temp.UseStatus = "已核销"
                this.canUse = 0;
              } else {
                Dialog.alert({
                  message: res.message,
                });
              }
            })
            .catch(() => {
              this.saveLoading = false;
              // Toast("提交失败，请重新提交！");
              Dialog.alert({
                message: "提交失败，请重新提交！",
              });
            });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/Ticket/index.vue